import React from 'react';
import {DataGrid as MDDataGrid} from '@material-ui/data-grid';
import {IconButton} from '@material-ui/core';
import {ArrowDropUp, ArrowDropDown} from '@material-ui/icons';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    button:
    {
        width: 30,
        height: 30,
        padding: 3,
        alignSelf: "center"
    },
    columnArrows:
    {
        display: "flex",
        flexDirection: "column",
        width: 24,
        height: 24,
        alignItems: "center",
        alignSelf: "center",
        justifyContent: "center"
    },
    arrow:
    {
        color: theme.palette.text.primary,
        opacity: 0.5,
        lineHeight: 0.5,
        fontSize: "15px",
        margin: -4,
        padding: 0,
        '&.highlighted':
        {
            opacity: 1
        }
    }
  }), {name: "Datagrid"});


function ArrowUnsorted()
{
    const classes = useStyles();
    return <div className={classes.columnArrows}>
        <ArrowDropUp className={classes.arrow}/>
        <ArrowDropDown className={classes.arrow}/>
    </div>
}

function ArrowSortAsc()
{
    const classes = useStyles();
    return <div className={classes.columnArrows}>
        <ArrowDropUp className={clsx(classes.arrow, "highlighted")}/>
        <ArrowDropDown className={classes.arrow}/>
    </div>
}

function ArrowSortDesc()
{
    const classes = useStyles();
    return <div className={classes.columnArrows}>
        <ArrowDropUp className={classes.arrow}/>
        <ArrowDropDown className={clsx(classes.arrow, "highlighted")}/>
    </div>
}


function DataGrid({columns = [], sortModel = [], ...props})
{
    const classes = useStyles();


    function handleSortChanged(sortProps)
    {
        const sortedFields = sortProps.sortModel.map((model) => model.field);
        sortProps.columns.forEach((column) => {
            if(sortedFields.includes(column.field)) column.isSorted = true;
            else column.isSorted = false;
        });
    }

    function renderArrows(params)
    {
        const drawSortable = params.colDef.sortable && !params.colDef.disableClickEventBubbling && !params.colDef.isSorted;

        return <>
            <strong>{params.colDef.headerName}</strong>
            {drawSortable ? <div><IconButton className={classes.button}><ArrowUnsorted /></IconButton></div> : ""}
        </>
    }

    handleSortChanged({columns: columns, sortModel: sortModel});

    columns.forEach((column) => {
        column.renderHeader = renderArrows;
    });

    function empty() {return <></>}

    return <MDDataGrid 
    pageSize={100}
    hideFooter
    disableColumnMenu={true}
    columns={columns}
    sortModel={sortModel}
    onSortModelChange={handleSortChanged}
    components={{ColumnSortedAscendingIcon: ArrowSortAsc, ColumnSortedDescendingIcon: ArrowSortDesc}}
    localeText={{noRowsLabel: 'Aún no hay elementos', errorOverlayDefaultLabel: "Ha ocurrido un error inesperado"}}
    {...props} />
}

export default DataGrid;